'use strict';
var angular = require('angular');

var payloadCtrl = [function () {
    var _this = this;
    if (!this.payload) {
        this.payload = [];
    }
    
    if(!this.payloadhidden)
        this.payloadhidden = {}

    this.getHiddenStatus = function (index){
        return _this.payloadhidden[_this.payload[index].key]
    }

    this.addField = function (newValue) {
        // If modulo === template, value is not required.
        if (this.modulo === 'template') {
            // console.log('newValue', newValue);
            if (!newValue.key) {
                return;
            }

            _this.payload.push({
                key: newValue.key,
                value: newValue.value || '',
                fieldId: newValue.fieldId,
                id: Math.random().toString(36).substr(2, 9)
            });
        } else
        // If modulo is equal to task, value is required.
        if (this.modulo === 'task') {
            if (!newValue.key || !newValue.value) {
                return;
            }

            _this.payload.push({
                key: newValue.key,
                value: newValue.value,
                fieldId: newValue.fieldId,
                id: Math.random().toString(36).substr(2, 9)
            });
        }

        _this.payloadhidden[newValue.key] = false;

        _this.newPayload = {
            key: null,
            value: null,
            fieldId:null,
            hidden: false
        };
    };

    this.removeValue = function (index) {
        _this.payloadhidden[_this.payload[index].key]=undefined;
        _this.payload.splice(index, 1);
        
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            payload: '=',
            payloadhidden: '=',
            form: '=',
            modulo: '=',

        },
        controller: payloadCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-task/payloadDirective.html'
    };
};
